import React from 'react'
import { inject, observer } from 'mobx-react'

import Input from '../../../generic/Input'
import FormRenderer from '../../../generic/FormRenderer';
import MaskedInput from '../../../generic/MaskedInput';

const AddBranchForm = inject('configCompaniesStore')(observer(props => {
  const { configCompaniesStore } = props
  const { name, idCliente, certificado, senha_certificado, dir_xml, email, uf, cnpj } = configCompaniesStore.state.newBranch
  const formFields = [{
    component: Input,
    label: 'Nome',
    type: 'text',
    name: 'name',
    id: 'new-branch-name',
    placeholder: 'Nome',
    helpText: 'Preencher com o Nome da Filial',
    value: name,
    handler: (e) => configCompaniesStore.setNewBranchName(e.target.value)
  },{
    component: Input,
    label: 'ID Cliente',
    type: 'text',
    name: 'idCliente',
    id: 'new-branch-id-cliente',
    placeholder: 'ID Cliente',
    value: idCliente,
    helpText: 'Preencher com o código que será utilizado por este cliente na aplicação SAP',
    handler: (e) => configCompaniesStore.setNewBranchIdCliente(e.target.value)
  },{
    component: Input,
    label: 'Certificado',
    type: 'text',
    name: 'certificado',
    id: 'new-branch-certificado',
    placeholder: 'Certificado',
    value: certificado,
    helpText: 'Preencher o nome do arquivo do certificado digital importado. Extensão PFX',
    handler: (e) => configCompaniesStore.setNewBranchCertificado(e.target.value)
  },{
    component: Input,
    label: 'Senha do certificado',
    type: 'password',
    name: 'senha_certificado',
    id: 'new-branch-senha-certificado',
    placeholder: 'Senha do certificado',
    value: senha_certificado,
    helpText: 'Preencher com a senha do certificado digital',
    handler: (e) => configCompaniesStore.setNewBranchSenhaCertificado(e.target.value)
  },{
    component: Input,
    label: 'Diretório do XML',
    type: 'input',
    name: 'dir_xml',
    id: 'new-branch-dir-xml',
    placeholder: 'Diretório do XML',
    value: dir_xml,
    helpText: 'Preencher com o diretório que será salvo o arquivo XML. EMPRESA/FILIAL. Exemplo: LETNIS1000/0001',
    handler: (e) => configCompaniesStore.setNewBranchDirXml(e.target.value)
  },{
    component: Input,
    label: 'E-mail',
    type: 'input',
    name: 'email',
    id: 'new-branch-email',
    placeholder: 'E-mail',
    value: email,
    helpText: 'Email do responsável pelo produto no cliente.',
    handler: (e) => configCompaniesStore.setNewBranchEmail(e.target.value)
  },{
    component: MaskedInput,
    label: 'UF',
    type: 'input',
    name: 'uf',
    id: 'new-branch-UF',
    placeholder: 'UF',
    value: uf,
    helpText: 'Preencher com o código de UF utilizado pelo SEFAZ. Exemplo: 35',
    maskFunction: () => [/\d/,/\d/],
    handler: (e) => configCompaniesStore.setNewBranchUf(e.target.value)
  },{
    component: MaskedInput,
    label: 'CNPJ',
    type: 'input',
    name: 'cnpj',
    id: 'new-branch-cnpj',
    placeholder: 'CNPJ',
    value: cnpj,
    helpText: 'Preencher com o código de UF utilizado pelo SEFAZ. Exemplo: 35',
    handler: (e) => configCompaniesStore.setNewBranchCnpj(e.target.value),
    maskFunction: () => [/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/],
  }]
  return (
    <form>
      <FormRenderer fields={formFields} store={configCompaniesStore} />
    </form>
  )
}))

export default AddBranchForm



// WEBPACK FOOTER //
// ./src/components/dashboard/config/companies/AddBranchForm.js